/**
 * Bingo Page
 *
 * Main page for goal bingo card management.
 */

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BingoCardList, BingoCardCreate } from '@/components/bingo';

export function BingoPage() {
  const navigate = useNavigate();
  const [showCreateModal, setShowCreateModal] = useState(false);

  const handleCreateSuccess = (cardId: string) => {
    setShowCreateModal(false);
    navigate(`/bingo/${cardId}`);
  };

  return (
    <div className="space-y-6">
      <BingoCardList onCreateClick={() => setShowCreateModal(true)} />
      <BingoCardCreate
        isOpen={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        onSuccess={handleCreateSuccess}
      />
    </div>
  );
}


